import { Icon } from '@iconify/react';
import ConfirmDialog from './ConfirmDialog';
import { fmtPhone } from '../visitorConstants';

// Delete is soft on the server, but the phone number stays reserved and there
// is no restore endpoint — so the record is effectively unrecoverable and the
// number can never be registered again. The warning says so before the click,
// and points at blocking as the reversible alternative.
const DeleteVisitorDialog = ({ visitor, busy = false, onConfirm, onCancel }) => (
    <ConfirmDialog
        open={!!visitor}
        title="Remove visitor?"
        subtitle="This cannot be undone."
        confirmLabel="Remove"
        busyLabel="Removing..."
        tone="danger"
        icon="mdi:trash-can-outline"
        busy={busy}
        onConfirm={onConfirm}
        onCancel={onCancel}
    >
        <p className="tw-mb-3">
            You are about to remove <span className="tw-font-semibold">{visitor?.name}</span> ({fmtPhone(visitor?.phone)}).
        </p>
        <div className="tw-flex tw-items-start tw-gap-2 tw-px-2.5 tw-py-2 tw-rounded-md tw-bg-amber-50 tw-border tw-border-amber-100 tw-text-[10px] tw-text-amber-800">
            <Icon icon="mdi:alert-outline" className="tw-text-sm tw-shrink-0 tw-mt-px" />
            <span>
                This number stays reserved after removal and cannot be registered again.
                To stop them at the gate but keep the record, block them instead.
            </span>
        </div>
    </ConfirmDialog>
);

export default DeleteVisitorDialog;
